module.exports = __webpack_public_path__ + "static/media/urban-one-builders.ec17f690.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/urban-one-builders.svg
// module id = 384
// module chunks = 0